var map = {
	"./1599px-Adams_Creation_Sistine_Chapel_ceiling_by_Michelangelo_JBU33.jpg": 643,
	"./Hillary-and-Norgay1.jpg": 712,
	"./Lunch_atop_a_Skyscraper_-_Charles_Clyde_Ebbets.jpg": 687,
	"./Nighthawks_by_Edward_Hopper_1942.jpg": 595,
	"./PicassoGuernica.jpg": 389,
	"./The_Earth_seen_from_Apollo_17.jpg": 777,
	"./Vitruvian-Man-Crop.jpg": 775,
	"./apollo08_earthrise.webp": 434,
	"./baltic-human-chain.jpg": 102,
	"./caveofhands.jpg": 799,
	"./in-1991-metallica-performed-in-moscow-at-a-military-v0-chj4ioly03sc1.jpg": 820,
	"./mars-perseverance-selfie-how-did-it-happen-banner.jpeg": 95,
	"./muhammad-ali-sonny-liston-ii-001292890jpg.jpg": 844,
	"./walking_free.jpg": 879
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 153;